import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import DocumentTitle from 'react-document-title';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { getOr } from 'lodash/fp';
import { Input, Select } from 'antd';
import ENUMS from '../../constants/enums';
import WideButton from '../../components/common/WideButton';
import { title } from '../../constants';
import { ColumnFlex, RowFlex } from '../../components/common/FlexStyle';
import { discoveryFetchesCount, discoveryFetchesTimeout } from '../../constants/discover';
import Spinner from '../../components/common/spinner';
import { eNumToIntel } from '../../utils/eNumsConverters';
import { convertDestinationMarketsEnumsToStrings } from '../../utils/Discover';
import DiscoveryInputsWrapper from '../../components/DiscoveryInputsWrapper';
import IconSvg from '../../components/common/IconSvg';
import { themeColors } from '../../constants/themes';
import TmModal from '../../components/common/TmModal';

const { Option } = Select;

@injectIntl
@inject('settingsStore')
@inject('discoveryStore')
@inject('routingStore')
@inject('toastsStore')
@inject('enumsStore')
@inject('sessionStore')
@observer
class ExpressDL extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerShown: false,
      editStrategy: false,
      profit: '',
      breakEven: '',
      // fixedFee: '',
      badFormat: false,
      formsInitialized: false,
      isVeroFailureModalVisible: false,
      failedDiscoveryId: null,
      failedTitleWords: [],
      failedBrandWords: [],
      failedSellerWords: [],
      failedDescriptionWords: [],
      // settingsInitialized: props.settingsStore.initialized
    };
    this.fetchDiscover = this.fetchDiscover.bind(this);
    this.initializeForms = this.initializeForms.bind(this);
    this.countOfFetches = 0;
    this.fetchStartTime = 0;
  }

  componentDidMount() {
    const {
      settingsStore: { initialized },
    } = this.props;
    if (initialized) {
      this.initializeForms();
    }
  }

  /** sending the discover id to check if the discover ids ready
   * It's temporary function until the sockets will work
   * @param {number} newDiscover the id to check if the discover is ready
   */
  getDiscoverFromQ = newDiscover => {
    const {
      routingStore,
      discoveryStore: { setDiscoveryId, isSingleDiscover },
    } = this.props;
    setDiscoveryId(null);
    if (isSingleDiscover) {
      setTimeout(() => {
        this.getDiscoverFromQFunc(newDiscover);
      }, 1000);
    } else {
      routingStore.browserHistory.push('/discover');
    }
  };

  getDiscoverFromQFunc = newDiscover => {
    const { discoveryStore, routingStore, enumsStore, toastsStore, intl } = this.props;
    this.countOfFetches++;
    discoveryStore
      .fetchByDiscoveryId(newDiscover)
      .then(response => {
        const timePassed = Date.now() - this.fetchStartTime;
        if (this.countOfFetches < discoveryFetchesCount && timePassed < discoveryFetchesTimeout) {
          if (response && response.statusId === enumsStore.enums.DISCOVERY_ITEM_STATUS.FAILED) {
            this.setState({ spinnerShown: false });
            this.countOfFetches = 0;
            discoveryStore.getQList().then(() => {
              routingStore.browserHistory.push('/discover');
            });
            return;
          } else if (
            response &&
            response.statusId === enumsStore.enums.DISCOVERY_ITEM_STATUS.VALIDATION_FAILED
          ) {
            this.setState({
              spinnerShown: false,
              isVeroFailureModalVisible: true,
              failedDiscoveryId: response.id,
              failedTitleWords: response.failedTitleWords,
              failedBrandWords: response.failedBrandWords,
              failedSellerWords: response.failedSellerWords,
              failedDescriptionWords: response.failedDescriptionWords,
            });
            return;
          }
          if (!response || !response.discoveryItems) {
            console.log(
              `NOT DONE YET ${this.countOfFetches}/${discoveryFetchesCount}\n${timePassed}`,
            );
            this.getDiscoverFromQ(newDiscover);
            this.setState({ spinnerShown: true });
            return;
          }
          // TODO: have to be 1
          if (response.discoveryItems.length) {
            routingStore.browserHistory.push(`/discover/singleResult?discovery-id=${response.id}`);
          } else {
            routingStore.browserHistory.push('/discover');
          }
          this.countOfFetches = 0;
          this.setState({ spinnerShown: false });
        } else {
          this.countOfFetches = 0;
          this.setState({ spinnerShown: false });
          toastsStore.showToast({
            type: enumsStore.enums.TOAST_TYPES.WARNING,
            message: intl.formatMessage({ id: 'discovery.timeout' }),
          });
          discoveryStore.getQList().then(() => {
            routingStore.browserHistory.push('/discover');
          });
        }
      })
      .catch(err => {
        console.log(err);
        this.countOfFetches = 0;
        this.setState({ spinnerShown: false });
      });
  };

  setProfit = e => {
    const {
      breakEven,
      // fixedFee
    } = this.state;
    const profit = getOr('', 'target.value', e);
    const badFormat = !(/^[0-9]*$/g.test(breakEven) && /^[0-9]*$/g.test(profit));
    // && /^([0-9]*[.])?[0-9]*$/g.test(fixedFee)
    this.setState({ profit, badFormat });
  };

  setBreakEven = e => {
    const {
      profit,
      // fixedFee
    } = this.state;
    const breakEven = getOr('', 'target.value', e);
    const badFormat = !(/^[0-9]*$/g.test(breakEven) && /^[0-9]*$/g.test(profit));
    // && /^([0-9]*[.])?[0-9]*$/g.test(fixedFee)
    this.setState({ breakEven, badFormat });
  };

  setFixedFee = e => {
    const { profit, breakEven } = this.state;
    const fixedFee = getOr('', 'target.value', e);
    const badFormat = !(
      /^[0-9]*$/g.test(breakEven) &&
      /^[0-9]*$/g.test(profit) &&
      /^([0-9]*[.])?[0-9]*$/g.test(fixedFee)
    );
    this.setState({
      // fixedFee,
      badFormat,
    });
  };

  initializeForms = () => {
    const { discoveryStore, enumsStore } = this.props;
    const {
      availableSourceMarketPlaces,
      setDiscoverMarket,
      setListingSelected,
      getSellersAccounts,
    } = discoveryStore;
    const {
      enums: {
        SOURCE_MARKETPLACE: { AMAZON_US, AMAZON_UK, AMAZON_CA, AMAZON_DE, AMAZON_IT, AMAZON_FR, AMAZON_ES },
        DESTINATION_MARKETPLACE: { EBAY_US, EBAY_GB, EBAY_CA, EBAY_DE, EBAY_IT, EBAY_FR, EBAY_ES },
      },
    } = enumsStore;

    this.setState({ formsInitialized: true, spinnerShown: true });
    const marketCondition = availableSourceMarketPlaces.find(el => el === AMAZON_US);
    if (marketCondition === AMAZON_US) {
      setDiscoverMarket(AMAZON_US);
      setListingSelected(EBAY_US);
    } else if (availableSourceMarketPlaces.find(el => el === AMAZON_UK)) {
      setDiscoverMarket(AMAZON_UK);
      setListingSelected(EBAY_GB);
    } else if (availableSourceMarketPlaces.find(el => el === AMAZON_CA)) {
      setDiscoverMarket(AMAZON_CA);
      setListingSelected(EBAY_CA);
    }
    else if (availableSourceMarketPlaces.find(el => el === AMAZON_DE)) {
      setDiscoverMarket(AMAZON_DE);
      setListingSelected(EBAY_DE);
    }
    else if (availableSourceMarketPlaces.find(el => el === AMAZON_IT)) {
      setDiscoverMarket(AMAZON_IT);
      setListingSelected(EBAY_IT);
    }
    else if (availableSourceMarketPlaces.find(el => el === AMAZON_FR)) {
      setDiscoverMarket(AMAZON_FR);
      setListingSelected(EBAY_FR);
    }
    else if (availableSourceMarketPlaces.find(el => el === AMAZON_ES)) {
      setDiscoverMarket(AMAZON_ES);
      setListingSelected(EBAY_ES);
    }
    getSellersAccounts().then(resp => {
      if (resp && resp.length) {
        this.handleAccountSelect(JSON.stringify({ id: resp[0].id, name: resp[0].name }));
      }
      this.setState({ spinnerShown: false });
    });
  };

  /**
   * sending the discover parameters for receiving the
   * discovery id
   */
  fetchDiscover = () => {
    const { discoveryStore, routingStore, toastsStore, enumsStore } = this.props;
    const { sendDiscover, discoverStrategy, isSingleDiscover } = discoveryStore;
    if (discoverStrategy === 0) {
      console.log('No discoverStrategy selected');
      return;
    }
    this.setState({
      spinnerShown: true,
    });
    sendDiscover().then(resp => {
      if (!resp.errorMessage) {
        if (!isSingleDiscover) {
          toastsStore.showToast({
            type: enumsStore.enums.TOAST_TYPES.INFO,
            message: 'discover.discoverRequestSuccessful',
          });
          discoveryStore.getQList().then(() => {
            this.setState({
              spinnerShown: false,
            });
            routingStore.browserHistory.push('/discover');
          });
        }
      } else {
        this.setState({
          spinnerShown: false,
        });
        toastsStore.showToast({
          type: enumsStore.enums.TOAST_TYPES.WARNING,
          message: resp.errorMessage,
        });
      }
    });
  };

  handleAccountSelect = account => {
    const {
      routingStore,
      discoveryStore,
      enumsStore,
      toastsStore,
      sessionStore: { isNonApi },
    } = this.props;
    discoveryStore.setSellerAccount(JSON.parse(account));
    this.setState({ spinnerShown: true });
    discoveryStore
      .getStrategyDefaults()
      .then(response => {
        if (response) {
          if (convertDestinationMarketsEnumsToStrings(discoveryStore.listingMarket) !== 'AZD_US') {
            discoveryStore.getPoliciesForSellerAccount().then(policies => {
              this.setState({ spinnerShown: false });
              if ((!policies || !policies.length) && !isNonApi) {
                toastsStore.showToast({
                  type: enumsStore.enums.TOAST_TYPES.WARNING,
                  message: 'No seller policies found, try again!',
                });
                routingStore.browserHistory.push('/discover');
              }
            });
          }
          discoveryStore.setStrategy(Number(Object.keys(response.toJSON())[0]));
          const {
            discoveryStore: { strategies, discoverStrategy },
          } = this.props;
          this.setState({
            breakEven: strategies.get(`${discoverStrategy}`).properties.breakEven,
            profit: strategies.get(`${discoverStrategy}`).properties.profit,
            // fixedFee: strategies.get(`${discoverStrategy}`).properties.fixedFee
          });
        } else {
          this.setState({ spinnerShown: false });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  handleListingMarketChange = listingMarket => {
    const { discoveryStore } = this.props;
    const { setListingSelected, getSellersAccounts } = discoveryStore;

    setListingSelected(listingMarket);
    getSellersAccounts().then(resp => {
      if (resp && resp.length) {
        this.handleAccountSelect(JSON.stringify({ id: resp[0].id, name: resp[0].name }));
      }
      this.setState({ spinnerShown: false });
    });
  };

  saveStrategyProperties = () => {
    const {
      discoveryStore: { strategies, discoverStrategy },
      enumsStore: {
        enums: {
          STRATEGY: { FIXED_PROFIT },
        },
      },
    } = this.props;
    const { profit, breakEven } = this.state;
    strategies.get(`${discoverStrategy}`).setProperties(FIXED_PROFIT, 'profit', profit);
    strategies.get(`${discoverStrategy}`).setProperties(FIXED_PROFIT, 'breakEven', breakEven);
  };

  toggleStrategy = () => {
    const { editStrategy } = this.state;
    this.setState({ editStrategy: !editStrategy });
  };

  proceedDespiteVero = () => {
    this.setState({ isVeroFailureModalVisible: false, spinnerShown: true });
    const { failedDiscoveryId } = this.state;
    const { discoveryStore, routingStore, toastsStore, enumsStore } = this.props;
    discoveryStore.tryAgainDespiteVero(failedDiscoveryId).then(success => {
      if (success)
        setTimeout(() => {
          this.getDiscoverFromQ(failedDiscoveryId);
        }, 1000);
      else {
        toastsStore.showToast({
          type: enumsStore.enums.TOAST_TYPES.WARNING,
          message: 'Discover failed',
        });
        this.setState({ spinnerShown: false });
        routingStore.browserHistory.push('/discover');
      }
    });
  };

  dropDiscovery = () => {
    const { failedDiscoveryId } = this.state;
    const { discoveryStore, routingStore } = this.props;
    discoveryStore.deleteDiscovery(failedDiscoveryId).then(() => {
      this.setState({ isVeroFailureModalVisible: false });
      routingStore.browserHistory.push('/discover');
    });
  };

  renderModals = () => {
    const { intl } = this.props;
    const {
      isVeroFailureModalVisible,
      failedTitleWords,
      failedBrandWords,
      failedSellerWords,
      failedDescriptionWords,
    } = this.state;
    return (
      <React.Fragment>
        <TmModal
          type="warning"
          title={intl.formatMessage({ id: 'qList.failedVero' })}
          visible={isVeroFailureModalVisible}
          mainActionBtn={{
            btnType: 'secondary',
            text: `${intl.formatMessage({ id: 'discover.proceedAnyway' })}`,
            clickHandler: () => {
              this.proceedDespiteVero();
            },
          }}
          secondaryActionBtn={{
            text: `${intl.formatMessage({ id: 'discover.dropDiscovery' })}`,
            clickHandler: () => {
              this.dropDiscovery();
            },
          }}
        >
          <h3>Discovery failed VERO because of the following:</h3>
          {failedTitleWords.length > 0 && (
            <h3>Title contains these forbidden words: {failedTitleWords.join('/')}</h3>
          )}
          {failedBrandWords.length > 0 && (
            <h3>Brand contains these forbidden words: {failedBrandWords.join('/')}</h3>
          )}
          {failedDescriptionWords.length > 0 && (
            <h3>Description contains these forbidden words: {failedDescriptionWords.join('/')}</h3>
          )}
          {failedSellerWords.length > 0 && (
            <h3>Item from forbidden seller: {failedSellerWords.join('/')}</h3>
          )}
        </TmModal>
      </React.Fragment>
    );
  };

  render() {
    const {
      editStrategy,
      breakEven,
      profit,
      badFormat,
      formsInitialized,
      // fixedFee
    } = this.state;
    const {
      intl: { formatMessage },
      enumsStore: {
        enums: {
          DESTINATION_MARKETPLACE,
          STRATEGY: { FIXED_PROFIT },
          SETTINGS_TABS: { PRICING },
        },
      },
      discoveryStore,
      settingsStore: { initialized, toggleSettings, markets },
      routingStore: { browserHistory },
    } = this.props;
    const {
      discoverMarket,
      listingMarket,
      availableSourceMarketPlaces,
      setDiscoverMarket,
      sellersAccounts = [''],
      sellerAccountCode,
      sellerAccountName,
      setStrategy,
      strategies,
      discoverStrategy,
      discoveryId,
      rangedProfitSelected,
      penetrationProfitSelected,
    } = discoveryStore;

    if (discoveryId) {
      console.log('started waiting');
      this.fetchStartTime = Date.now();
      this.getDiscoverFromQ(discoveryId);
    }
    if (initialized && !formsInitialized) {
      this.initializeForms();
    }
    const loadedStrategies = strategies.size
      ? [Object.keys(strategies.toJSON())[0]] // array containing only the first strategy id
      : [FIXED_PROFIT];

    return (
      <DocumentTitle title={`${title} | Express Discover`}>
        <div className="DiscoverAndList">
          {this.state.spinnerShown && <Spinner />}
          {this.renderModals()}
          <ColumnFlex className="discoverProgressContainer" style={{ height: 'auto' }}>
            <RowFlex style={{ marginBottom: '16px' }}>
              <div className="discoverHeaderTitle">
                {formatMessage({ id: 'discovery.expressDL' })}
              </div>
            </RowFlex>
            <RowFlex
              style={{
                width: 'min(1077px, 100%)',
                margin: '0px auto 20px',
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
              css={css`
                & > div {
                  margin-bottom: 7px;
                }
              `}
            >
              <WideButton
                big
                title={formatMessage({ id: 'discovery.discoverAndList' })}
                value={
                  <Select
                    value={discoverMarket}
                    css={css`
                      width: 120px;
                    `}
                    onChange={market => {
                      setDiscoverMarket(market);
                      this.handleAccountSelect(
                        JSON.stringify({ id: sellerAccountCode, name: sellerAccountName }),
                      );
                    }}
                  >
                    {availableSourceMarketPlaces.map(market => (
                      <Option value={market} key={`discoverMarket-${market}`}>
                        {formatMessage({ id: `discovery.marketByEnum_${market}` })}
                      </Option>
                    ))}
                  </Select>
                }
              />
              <WideButton
                big
                title={formatMessage({ id: 'discovery.destination' })}
                value={
                  <Select
                    value={listingMarket}
                    onChange={this.handleListingMarketChange}
                    css={css`
                      width: 200px;
                    `}
                  >
                    {markets.getDestinations.map(item => (
                      <Option value={DESTINATION_MARKETPLACE[item.id]} key={item.id}>
                        {eNumToIntel('DESTINATION_MARKETPLACE', DESTINATION_MARKETPLACE[item.id])}
                      </Option>
                    ))}
                  </Select>
                }
              />
              <WideButton
                big
                title={formatMessage({ id: 'discover.selectedAccount' })}
                value={
                  <Select
                    showSearch
                    value={
                      sellersAccounts.length > 0
                        ? JSON.stringify({ id: sellerAccountCode, name: sellerAccountName })
                        : 'No store connected'
                    }
                    onChange={this.handleAccountSelect}
                    css={css`
                      width: 200px;
                    `}
                  >
                    {sellersAccounts.map(account => (
                      <Option
                        value={JSON.stringify({ id: account.id, name: account.name })}
                        key={`sellers-account-${account.id}`}
                      >
                        {account.name}
                      </Option>
                    ))}
                    <Option value={JSON.stringify({ id: '', name: '' })} />
                  </Select>
                }
              />
              <div style={{ position: 'relative' }}>
                <WideButton
                  big
                  title={formatMessage({ id: 'discovery.strategy' })}
                  value={
                    editStrategy ? (
                      <React.Fragment>
                        <span>Break Even: </span>
                        <Input
                          value={breakEven}
                          onChange={this.setBreakEven}
                          style={{ width: '50px' }}
                        />
                        <span style={{ marginLeft: '10px' }}>Profit (%): </span>
                        <Input value={profit} onChange={this.setProfit} style={{ width: '50px' }} />
                        {/* {typeof fixedFee !== 'undefined' ? ( */}
                        {/*   <React.Fragment> */}
                        {/*     <span style={{marginLeft:'10px'}}>Fixed Fee: </span> */}
                        {/*     <Input */}
                        {/*       value={fixedFee} */}
                        {/*       onChange={this.setFixedFee} */}
                        {/*       style={{width: '50px'}} */}
                        {/*     /> */}
                        {/*   </React.Fragment> */}
                        {/* ) : null} */}
                      </React.Fragment>
                    ) : (
                      <Select
                        value={discoverStrategy || loadedStrategies[0]}
                        onChange={setStrategy}
                      >
                        {loadedStrategies.map(strategy => (
                          <Option value={Number(strategy || 0)} key={`sellers-account-${strategy}`}>
                            {strategy && eNumToIntel('pricingStrategies', strategy)}
                            {strategy &&
                              strategies.get(strategy) &&
                              `,
                            Break Even ${strategies.get(strategy).properties.breakEven},
                            Profit ${strategies.get(strategy).properties.profit}%
                            ${strategies.get(strategy).properties.fixedFee !== undefined
                                ? `, Fixed Fee ${strategies.get(strategy).properties.fixedFee}`
                                : ''
                              }
                           `}
                          </Option>
                        ))}
                        <Option value="ranged">
                          {formatMessage({ id: 'pricing.rangedProfit' })}
                        </Option>
                        <Option value={ENUMS.STRATEGY.PENETRATION}>
                          {formatMessage({ id: 'pricing.penetration' })}
                        </Option>
                      </Select>
                    )
                  }
                />
                {badFormat && (
                  <span
                    style={{
                      position: 'absolute',
                      color: themeColors.pink,
                      margin: '5px 0 0 30px',
                    }}
                  >
                    Please input valid number
                  </span>
                )}
              </div>
              {!badFormat && (
                <a
                  onClick={() => {
                    if (rangedProfitSelected) {
                      toggleSettings(PRICING);
                      return;
                    }
                    if (penetrationProfitSelected) {
                      toggleSettings(PRICING);
                      return;
                    }
                    if (editStrategy) {
                      this.saveStrategyProperties();
                    }
                    this.toggleStrategy();
                  }}
                >
                  {editStrategy ? 'save' : 'edit'}
                </a>
              )}
            </RowFlex>
          </ColumnFlex>
          <DiscoveryInputsWrapper
            discoveryStore={discoveryStore}
            browserHistory={browserHistory}
            isDisabled={false}
            formatMessage={formatMessage}
            key={discoverMarket}
            afterChange={this.fetchDiscover}
            buttonContent={
              <React.Fragment>
                {formatMessage({ id: 'discovery.newDiscover' })}
                <IconSvg style={{ marginLeft: '7px' }} type="discover_glasses" size={20} />
              </React.Fragment>
            }
            messageId="discover.differentTextForSelectYourDiscoveryMethod"
          />
        </div>
      </DocumentTitle>
    );
  }
}

ExpressDL.propTypes = {
  discoveryStore: PropTypes.object,
  routingStore: PropTypes.object,
  toastsStore: PropTypes.object,
  enumsStore: PropTypes.object,
  intl: PropTypes.object,
  settingsStore: PropTypes.object,
  sessionStore: PropTypes.object,
};

export default ExpressDL;
